module.exports = __webpack_public_path__ + "img/空白（版心宽+居中页码）.0521a8fc.jpg";